// extracted by mini-css-extract-plugin
export default {"content":"JxGH3","search-section":"Ep27C"};